<template>
  <v-row justify='center'>
    <v-dialog
      v-model='exportDialog'
      persistent
      max-width='400'
    >
      <v-card>
        <v-card-title class='headline'>
          Exportar lista "{{ listName }}"
        </v-card-title>
        <v-card-text>
          Escolha o e-mail do usuário para qual será exportado esta lista
          <v-select
            v-model='userEmailToExport'
            :items='usersList'
            :prepend-icon='mdiAccount'
            label='E-mail'
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click='exportDialog = false; userEmailToExport = ""'
          >
            Cancelar
          </v-btn>
          <v-btn
            color='primary'
            @click='exportDialog = false; exportUserList(index, listName); userEmailToExport = ""'
          >
            Exportar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import firebase from '@/api/firebase'
import { mdiAccount } from '@mdi/js'

export default {
  name: 'ConfirmExportListModal',
  props: {
    user: {
    type: Object,
    default: new Object()
    },
  },
  data () {
  return {
    exportDialog: false,
    listName: '',
    index:0,
    usersList: [],
    mdiAccount,
    userEmailToExport:'',
    experiencesToExport:[],
    toastOptions: {
        position: 'bottom-center',
        duration: 3000
      },
  }
  },
  async created () {
    this.getUsersList()
  },
  methods: {
    open (index, listName) {
      this.listName = listName
      this.index = index
      this.exportDialog = true
      this.experiencesToExport = []
    },
    async getUsersList(){
      let vm = this
      let params = {
        'orderBy': 'asc'
      }
      let userIDs = await firebase.getAllUsers(params)
      userIDs.forEach(
      function (doc) {
        if(doc.data().email != undefined){
          vm.usersList.push(doc.data().email)
        }
      })
    },
    async exportUserList(index, listName) {
      this.user.lists[index].experiences.forEach(list => {
        this.experiencesToExport.push(list.id)
      })
      let params = {
        'userEmail': this.userEmailToExport
      }
      let docRef = await firebase.getUserByEmail(params)
      this.userEmailToExport = docRef.docs[0].id
      params = {
        'id': this.userEmailToExport,
        'listName': listName,
        'experiencesID': this.experiencesToExport
      }
      firebase.exportUserList(params).then( () =>{
        let text = 'Lista exportada com sucesso!'
        this.$toasted.show(text, this.toastOptions)
      })
      .catch( () => {
        let text = 'Houve um erro ao exportar a lista!'
        this.$toasted.show(text, this.toastOptions)
      })
    }
  },
}
</script>
